const COMMON = {
    CRIADO_EM: 'criadoEm',
    VENCIMENTO_SIMULACAO: 'vencimentoSimulacao',
    CODIGO_COTACAO: 'codigoCotacao',
    GARANTIA: 'inGarantia',
    CODIGO_ACESSO: 'codigoAcesso'
};

const DADOS_SIM = {
    DADOS_CLIENTE: {
        ...COMMON,
        CPF_CNPJ: 'cpfCnpj',
        NOME_EMPRESA: 'nomeEmpresa',
        TELEFONE: 'telefone',
        EMAIL: 'email',
        NUMERO_AGENCIA: 'numAgencia',
        NOME_AGENCIA: 'nomeAgencia',
        EMAIL_ADICIONAL: 'emailAdicional',
        TELEFONE_ADICIONAL: 'telefoneAdicional',
        EMAIL_SOLICITANTE: 'emailSolicitante'
    },
    LISTA_BENS: {
        ...COMMON,
        THIS: 'listaBens',
        ID: 'id',
        ANO: 'ano',
        ANOS_BEM: 'anosBem',
        ID_BEM: 'idBem',
        ID_TIPO_BEM: 'idTipoBem',
        ID_TIPO_CONSTRUCAO: 'idTipoConstrucao',
        NOME_BEM: 'nomeBem',
        TIPO_BEM: 'tipoBem',
        PRODUTO: 'produto',
        VALOR_UNITARIO_BEM: 'valorUnitario',
        TEMPO_VIGENCIA: 'tempoVigencia',
        TIPO_VIGENCIA: 'nomeTipoVigencia',
        VIGENCIA_SELETIVA: 'seletiva',
        VIGENCIA_PADRAO: 'padrao',
        DATA_FIM_VIGENCIA: 'fimVigencia',
        DATA_INICIO_VIGENCIA: 'inicioVigencia',
        COTACAO_CONTEUDO: 'cotacaoConteudos',
        QUESTIONARIO_RESPOSTAS: 'questionarioRespostas',
        RETANGULO_LISTA_BENS: 'statusRectangleColor',
        QUANTIDADE: 'quantidade',
        TEXTO_TIPO_CONSTRUCAO: 'tipoConstrucao',
        VALOR_TOTAL_BEM: 'valorTotal',
        UNIDADE_MEDIDA_BEM: 'unidadeMedida',
        VALOR_MINIMO: 'valorMinimo',
        VALOR_MAXIMO: 'valorMaximo',
        LISTA_BENS: 'bens',
        COBERTURAS_PERSONALIZADO: 'coberturasPersonalizado',
        RESPOSTA_RECUSADA: 'respostaRecusada',
        VALOR_LMI: 'valueLMI',
        ENDERECO: 'endereco',
        KML: 'kml',
        HAS_KML: 'hasKml',
        COORDENADAS: 'coordenadas',
        POLIGONOS: 'poligonos',
        CAMPOS_PREENCHIDOS: 'camposPreenchidos',
        RETANGULO_DADOS_COMPLEMENTARES: 'retanguloDadosComplementares',
        PREENCHIMENTO_TODOS_BENS: 'preenchimentoTodosBens',
        BENEFICIARIOS: 'beneficiarios',
        AGRAVO: 'agravo',
        DESCONTO: 'desconto'
    },
    DADOS_COTACAO: {
        ...COMMON,
        TIPO_COTACAO: 'tipoCotacao',
        STATUS_COTACAO: 'statusCotacao',
        CODIGO_ACESSO: 'codigoAcesso',
        NOME_COOPERATIVA: 'nomeCooperativa',
        ID_TIPO_COTACAO: 'idTipoCotacao',
        NUMERO_PRODUTO: 'nrProduto',
        PERC_AGRAVO: 'percentualAgravo',
        PERC_DESCONTO: 'percentualDesconto'
    },
    CONTEUDO: {
        ID_CONTEUDO: 'idConteudo',
        TIPO_CONTEUDO: 'tipoConteudo',
        NOME_CONTEUDO: 'nomeConteudo',
        VALOR_MINIMO: 'valorMinimo',
        VALOR_MAXIMO: 'valorMaximo',
        UNIDADE_MEDIDA: 'unidadeMedida',
        QUANTIDADE: 'quantidade',
        VALOR_UNITARIO_CONTEUDO: 'valorUnitario',
        VALOR_TOTAL: 'valorTotal'
    },
    QUESTIONARIO_RESPOSTAS: {
        ID_REDIS: 'idRedis',
        ID_QUESTIONARIO: 'idQuestionario',
        PERGUNTA: 'pergunta',
        RESPOSTA: 'resposta',
        RESPOSTA_RECUSA: 'respostaRecusa',
        RECUSA: 'recusa',
        MENSAGEM_ERRO: 'mensagemErro'
    },
    BENEFICIARIOS: {
        THIS: 'listaBeneficiarios',
        ID_BENEFICIARIO: 'idBeneficiario',
        VALOR_LMI: 'valueLMI',
        APELIDO: 'apelidoBeneficiario',
        NOME_BENEFICIARIO: 'nomeBeneficiario',
        CPF_CNPJ_BENEFICIARIO: 'cpfCnpj',
        BENEFICIARIO_PROPRIO_SEGURADO: 'beneficiarioProprioSegurado',
        PERCENTUAL_PARTICIPACAO: 'percParticipacao'
    },
    ENDERECO: {
        THIS: 'listaEnderecos',
        ID_ENDERECO: 'idEndereco',
        NOME_PROPRIEDADE: 'nomePropriedade',
        UF: 'ufPropriedade',
        CIDADE: 'cidadePropriedade',
        CEP: 'cepPropriedade',
        RUA_ESTRADA: 'ruaEstradaPropriedade',
        NUMERO_PROPRIEDADE: 'numeroPropriedade',
        COMPLEMENTO: 'complementoPropriedade',
        BAIRRO_DISTRITO: 'bairroDistritoPropriedade'
    },
    DADOS_CEP: {
        CEP: 'nmCep',
        ABREVIATURALOGRADOURO: 'nmAbreveaturaLogradouro',
        CHAVEDNE: 'nmChaveDne',
        INICIALLOGRADOURO: 'nmInicialLogradouro',
        LOCALIDADE: 'nmLocalidade',
        UF: 'nmUf'
    },
    DETALHES_EQUIPAMENTOS: {
        FABRICANTE: 'fabricante',
        MODELO: 'modelo',
        CHASSI: 'chassi'
    },
    PAGAMENTO: {
        THIS: 'dadosFormaPagamento',
        FORMA_PAGAMENTO: 'formaPagamento',
        NOME_BANCO: 'nomeBanco',
        ID_BANCO_REDIS: 'id',
        ID_BANCO: 'bancoId',
        NUMERO_AGENCIA: 'numeroAgencia',
        DIGITO_AGENCIA: 'digitoAgencia',
        NUMERO_CONTA: 'numeroConta',
        DIGITO_CONTA: 'digitoConta',
        DIA_VENCIMENTO: 'diaVencimento',
        DIAS_VENCIMENTO_OPTIONS: 'diasVencimento',
        FORMAS_PAGAMENTO_OPTIONS: 'formasPagamento',
        CONTA_BB: 'contaBB',
        COMBO_PARCELAMENTO: 'comboMotorParcelamento'
    },
    COCORRETAGEM: {
        THIS: 'listaCorretagem',
        PERC_PARTIC_CORRETORA: (id = '') => `pcParticipacaoCorretor${id}`,
        PERC_PARTIC_CORRETORA1: 'pcParticipacaoCorretor1',
        PERC_PARTIC_CORRETORA2: 'pcParticipacaoCorretor2',
        PERC_PARTIC_CORRETORA3: 'pcParticipacaoCorretor3',
        PERC_PARTIC_BB_CORRETORA: 'pcParticipacaoCorretor1',
        NOME_CORRETORA: (id = '') => `nomeCorretora${id}`,
        NOME_CORRETORA1: 'nomeCorretora1',
        NOME_CORRETORA2: 'nomeCorretora2',
        NOME_CORRETORA3: 'nomeCorretora3',
        CNPJ_CORRETORA: (id = '') => `CNPJCorretora${id}`,
        CNPJ_CORRETORA1: 'CNPJCorretora1',
        CNPJ_CORRETORA2: 'CNPJCorretora2',
        CNPJ_CORRETORA3: 'CNPJCorretora3'
    },
    GEOLOCALIZACAO: {
        THIS: 'coordenadas',
        GRAU_LAT: 'grauLatitude',
        MINUTO_LAT: 'minutoLatitude',
        SEGUNDO_LAT: 'segundoLatitude',
        DIRECAO_LAT: 'direçãoLatitude',
        GRAU_LONG: 'grauLongitude',
        MINUTO_LONG: 'minutoLongitude',
        SEGUNDO_LONG: 'segundoLongitude',
        DIRECAO_LONG: 'direçãoLongitude',
        DESENHAR_BUTTON: 'desenharButton'
    },
    PERSONALIZADO: {
        CALCULAR_PERSONALIZADO: 'calcularPersonalizado'
    }
};

export default DADOS_SIM;
